<template>
  <CCard>
    <CCardHeader>
      <strong>New Category</strong>
    </CCardHeader>
    <CCardBody>
        <CRow class="mt-3">
        <CCol sm="6">
          <CSelect label="Parent Category" :options="categories" :value.sync="parent" />
        </CCol>
        </CRow>
      <CRow>
        <CCol sm="12">
          <CInput label="Name" placeholder="Enter Category name" v-model="name" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect
              label="Select Language"
              :options="languages"
              :value.sync="selected_language"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInputFile
            label="Image thumbnail"
            vertical
            ref="file"
            type="file"
            id="file"
            @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger"
            >(Image Size should be (360 X 360) and less than 1 MB)</label
          >
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"
        ><CIcon name="cil-check-circle" /> Add Category</CButton
      >
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "CategoryCreate",
  data() {
    return {
      name: "",
      image: "",
      categories: [{value: null, label : 'None'}],
      parent: null,
      languages: [{ value: 'en', label: 'English'}],
      selected_language: 'en'
    };
  },
  created() {
    this.getCategories();
    this.getLanguages();
  },
  methods: {
    getLanguages(){
      this.$axios
          .get(`${ADMIN_URL}/languages`)
          .then((response) => {
            console.log(response.data.languages)
            this.languages = response.data.languages
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onImageChange(e) {
      console.log("event", e[0]);
      this.image = e[0];
    },
    getCategories() {
      this.$axios
        .get(`${ADMIN_URL}/categories`)
        .then((response) => {
         let cats =  response.data.category_list.filter((f) => {
             return f.parent == ""

         })
          cats.forEach((e) => {
            this.categories.push({
              value: e.id,
              label: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("name", this.name);
      if(this.parent)
      {
     formData.append("parent", this.parent);
      }
 
      formData.append("image", this.image);
      formData.append("language", this.selected_language);
      

      this.$axios
        .post(`${ADMIN_URL}/categories`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
        //  window.location.href = "/categories";
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
  },
};
</script>

<style scoped>
</style>
